import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import FieldGroup from '../../FieldGroup.jsx';
import { validateEditorData } from '../../editor/defaultOptions.js';
import { FormError } from '../../FormError.jsx';
import MultistepFormsFooter from '../../MultistepFormsFooter.jsx';
import MultistepFormsNav from '../../headers/FormHeaders/MultistepFormsNav.jsx';

import Editor from '../../editor/editor.jsx';

function StepDetailsForm(props) {
  const {
    handleSubmit,
    onCancel,
    onBack,
    fields,
    updateEditorInstance,
    submitFailed,
    submitError,
    values,
    loading,
  } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Row className="flex flex-wrap flex-align-start">
        <Col xs={12}>
          <MultistepFormsNav
            type="portfolio"
            activeIndex={1}
            onBack={onBack}
            onSubmit={handleSubmit}
          />
        </Col>
        {fields
          ? fields.map(({ key, label, isEditor }, index) => {
              return isEditor ? (
                <Col key={key} xs={12}>
                  <Field name={key}>
                    {({ name, input, meta }) => {
                      return (
                        <Editor
                          name={name}
                          data={validateEditorData(input.value)}
                          label={label}
                          setEditorInstanceForParent={(editor) =>
                            updateEditorInstance(editor, index)
                          }
                          options={{
                            holder: `${key}-portfolio-editor`,
                            minHeight: '70',
                          }}
                          customClass="fixed-height"
                          meta={meta}
                        />
                      );
                    }}
                  </Field>
                </Col>
              ) : (
                <Col key={key} xs={12}>
                  <Field
                    name={key}
                    label={label}
                    componentClass="textarea"
                    rows={5}
                    customClass="fixed-height"
                    placeholder="Enter a Value"
                    component={FieldGroup}
                  />
                </Col>
              );
            })
          : null}
      </Row>
      <Row>
        <Col xs={12}>
          {submitFailed && submitError ? (
            <FormError submitError={submitError} />
          ) : null}
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <MultistepFormsFooter
            values={values}
            loading={loading}
            handleSubmit={handleSubmit}
            onCancel={onCancel}
            onBack={onBack}
            disabledSaveAndExit={loading}
          />
        </Col>
      </Row>
    </form>
  );
}

export default StepDetailsForm;
